import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

import Header from "./common/Header";
import Footer from "./common/Footer";
import SEO from "./common/SEO";
import Home from "./common/Home";
import Sigma from "./pages/Sigma";
import Impact from "./pages/Impact";
// Pages (Ab sab Direct Import hain - No Lazy Loading)
const About = lazy(() => import("./pages/About"));
const Offerings = lazy(() => import("./pages/Offerings"));
const IdeaValidatorTool = lazy(() => import("./pages/IdeaValidatorTool"));
const BusinessModelGenerator = lazy(
  () => import("./pages/BusinessModelGenerator"),
);
const FDIInstitute = lazy(() => import("./pages/FDIInstitute"));
const FDICRM = lazy(() => import("./pages/FDICRM"));
const TradeIntelligencePlateform = lazy(
  () => import("./pages/TradeIntelligencePlateform"),
);
const FDIIntelligencePlateform = lazy(
  () => import("./pages/FDIIntelligencePlateform"),
);
const Insights = lazy(() => import("./pages/Insights"));
const Resources = lazy(() => import("./pages/Resources"));
const Clients = lazy(() => import("./pages/Clients"));
const Contact = lazy(() => import("./pages/Contact"));
const Career = lazy(() => import("./pages/Career"));
const Elevate = lazy(() => import("./pages/Elevate"));
const Alpha = lazy(() => import("./pages/Alpha"));
const Beta = lazy(() => import("./pages/Beta"));
const Gamma = lazy(() => import("./pages/Gamma"));
const Signup = lazy(() => import("./pages/signupprocess/Singup"));
const Login = lazy(() => import("./pages/Login"));
const ThankYou = lazy(() => import("./pages/ThankYou"));
const Termofuse = lazy(() => import("./pages/Termofuse"));
const Podcast = lazy(() => import("./pages/Podcast"));
const Webinar = lazy(() => import("./pages/Webinar"));
const Blog = lazy(() => import("./pages/Blog"));
const Help = lazy(() => import("./pages/Help"));
const Bot = lazy(() => import("./pages/Bot"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const ShaktiSangam = lazy(() => import("./pages/ShaktiSangam"));
const Registrations = lazy(() => import("./pages/Registrations"));
const UserTracking = lazy(() => import("./pages/UserTracking"));
const Leadership = lazy(() => import("./pages/Leadership"));
const Plateform = lazy(() => import("./pages/Plateform"));

const IncubationConsulting = lazy(
  () => import("./pages/OurValueProposition/Consulting"),
);
const InvestmentPromotion = lazy(
  () => import("./pages/OurValueProposition/Investment"),
);
const StrategicAdvisoryToGovernments = lazy(
  () => import("./pages/OurValueProposition/AdvisoryToGovernments"),
);
const InternationalMarketEntryAssistance = lazy(
  () => import("./pages/OurValueProposition/MarketEntryAssistance"),
);
const TheFutureOfStartupIsHereEM = lazy(
  () => import("./pages/OurValueProposition/FutureOfStartup"),
);
const CuratedSectorSpecificCohorts = lazy(
  () => import("./pages/OurValueProposition/CuratedSector"),
);
const UniversitySignUpPage = lazy(
  () => import("./pages/UniversityPages/UniversitySignUpPages"),
);
const UniversitySignInPage = lazy(
  () => import("./pages/UniversityPages/UniversitySignInPages"),
);
// Scroll To Top Utility
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default function App() {
  useEffect(() => {
    const fetchCountryOnce = async () => {
      const storedCountry = localStorage.getItem("userCountry");
      if (!storedCountry) {
        try {
          const res = await fetch(
            "https://ipinfo.io/json?token=21f352ccc173b5",
          );
          const data = await res.json();
          if (data.country) {
            localStorage.setItem("userCountry", data.country);
            window.dispatchEvent(new Event("storage"));
          }
        } catch (err) {
          console.error("Geo-fetch failed:", err);
        }
      }
    };
    fetchCountryOnce();
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <SEO />
        <Header />
        <Suspense
          fallback={
            <div style={{ textAlign: "center", padding: "500px" }}>
              Loading page...
            </div>
          }
        >
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/our-offerings" element={<Offerings />} />
            <Route path="/career" element={<Career />} />
            <Route path="/platform" element={<Plateform />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/insights-resources" element={<Resources />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/insights" element={<Insights />} />

            {/* Tools */}
            <Route
              path="/startup-idea-validator-tools"
              element={<IdeaValidatorTool />}
            />
            <Route
              path="/business-model-generator"
              element={<BusinessModelGenerator />}
            />

            {/* FDI Platforms */}
            <Route path="/fdi-institute" element={<FDIInstitute />} />
            <Route path="/fdi-crm" element={<FDICRM />} />
            <Route
              path="/trade-intelligence-platform"
              element={<TradeIntelligencePlateform />}
            />
            <Route
              path="/fdi-intelligence-plateform"
              element={<FDIIntelligencePlateform />}
            />

            {/* Elevate Program */}
            <Route path="/elevate-by-im" element={<Elevate />} />
            <Route path="/alpha" element={<Alpha />} />
            <Route path="/beta" element={<Beta />} />
            <Route path="/gamma" element={<Gamma />} />
            <Route path="/sigma" element={<Sigma />} />
            <Route path="/impact" element={<Impact />} />

            {/* University Dashboard Pages */}
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/term-of-use" element={<Termofuse />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/institution-login"
              element={<UniversitySignInPage />}
            />
            <Route
              path="/institution-signup"
              element={<UniversitySignUpPage />}
            />

            {/* Media & Help */}
            <Route path="/podcast" element={<Podcast />} />
            <Route path="/webinar" element={<Webinar />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/help" element={<Help />} />
            <Route path="/chatbot" element={<Bot />} />

            {/* Events & Tracking */}
            <Route path="/shaktisangam2025" element={<ShaktiSangam />} />
            <Route path="/registrations" element={<Registrations />} />
            <Route path="ogs" element={<UserTracking />} />

            {/* Value Propositions */}
            <Route
              path="/startup-consulting"
              element={<IncubationConsulting />}
            />
            <Route
              path="/startup-investment"
              element={<InvestmentPromotion />}
            />
            <Route
              path="/startup-advisory"
              element={<StrategicAdvisoryToGovernments />}
            />
            <Route
              path="/startup-market-entry"
              element={<InternationalMarketEntryAssistance />}
            />
            <Route
              path="/startup-future-of-startup"
              element={<TheFutureOfStartupIsHereEM />}
            />
            <Route
              path="/startup-curated-sector"
              element={<CuratedSectorSpecificCohorts />}
            />

            {/* 404 Redirect to Home */}
            <Route path="*" element={<Home />} />
          </Routes>
        </Suspense>
        <Footer />

        <ToastContainer
          position="top-right"
          autoClose={4000}
          style={{ marginTop: "80px" }}
        />
      </BrowserRouter>
    </HelmetProvider>
  );
}
